<template>
  <el-dialog
    title="跟进记录"
    :visible.sync="dialogVisible"
    width="860px"
    @open="onOpen"
    @close="handleClose"
  >
    <div class="store-info">门店名称：{{ storeName }}</div>

    <el-table :data="list" border style="width: 100%" max-height="300px">
      <el-table-column label="跟进人" prop="followUserName" width="100" />
      <el-table-column label="跟进记录" prop="followContent" min-width="200" show-overflow-tooltip />
      <el-table-column label="图片记录" width="220">
        <template slot-scope="{ row }">
          <el-image
            v-for="(img, i) in row.imageList"
            :key="i"
            class="record-img"
            :src="getImageUrl(img)"
            :preview-src-list="row.imageList.map(getImageUrl)"
            fit="cover"
          />
          <span v-if="!row.imageList || row.imageList.length === 0">-</span>
        </template>
      </el-table-column>
      <el-table-column label="跟进时间" prop="followTime" width="170" />
    </el-table>

    <el-pagination
      small
      layout="total, prev, pager, next"
      :total="total"
      :current-page.sync="page"
      :page-size="pageSize"
      style="margin-top: 10px; text-align: right"
      @current-change="getList"
    />

    <el-divider />

    <el-form ref="addForm" :model="form" label-width="80px">
      <el-form-item
        label="跟进记录"
        prop="followContent"
        :rules="[{ required: true, message: '请输入跟进记录', trigger: 'blur' }]"
      >
        <el-input
          v-model="form.followContent"
          type="textarea"
          :rows="4"
          placeholder="请输入"
          style="width: 600px"
        />
      </el-form-item>
      <el-form-item label="跟进图片">
        <el-upload
          action="#"
          list-type="picture-card"
          :file-list="fileList"
          :http-request="handleUpload"
          :on-remove="handleRemove"
          :on-preview="handlePreview"
          :before-upload="beforeUpload"
          :limit="3"
          :on-exceed="handleExceed"
          style="width: 600px"
        >
          <i class="el-icon-plus" />
        </el-upload>
        <div class="tip">非必传，最多三张</div>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button size="small" @click="handleClose">关闭</el-button>
      <el-button type="primary" size="small" :loading="submitting" @click="handleSubmit">提交</el-button>
    </div>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="previewVisible" append-to-body width="600px">
      <img :src="previewUrl" style="width: 100%" />
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getFollowRecordPageAPI, addFollowRecordAPI } from './api'
import { getAliOssSts } from '@/components/file-upload/api'
import ossClient, { getFilePath } from '@/components/file-upload/oss'
import { localget, localset } from '@/utils/localStorage'
import { Loading } from 'element-ui'

export default {
  name: 'FollowRecord',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    storeCode: {
      type: String,
      default: '',
    },
    storeName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      form: {
        followContent: '',
        imageList: [],
      },
      fileList: [],
      uploadConf: {},
      submitting: false,
      previewVisible: false,
      previewUrl: '',
      loading: null,
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  mounted() {
    this.uploadConf = localget('alioss')
    if (!this.uploadConf || !this.uploadConf.domain) {
      getAliOssSts().then((res) => {
        this.uploadConf = {
          region: 'oss-cn-hangzhou',
          accessKeyId: res.accessKeyId,
          accessKeySecret: res.accessKeySecret,
          bucket: res.bucket,
          stsToken: res.securityToken,
          domain: res.domain,
        }
        localset('alioss', this.uploadConf, 1800)
      })
    }
  },
  methods: {
    onOpen() {
      this.page = 1
      this.getList()
    },
    async getList() {
      const res = await getFollowRecordPageAPI({
        storeCode: this.storeCode,
        page: this.page,
        pageSize: this.pageSize,
      })
      this.list = res.list || []
      this.total = res.total || 0
    },
    beforeUpload(file) {
      const isLt6M = file.size / 1024 / 1024 < 6
      return new Promise((resolve, reject) => {
        this.loading = Loading.service({
          lock: true,
          spinner: 'el-icon-loading',
          text: '上传中',
          background: 'rgba(0, 0, 0, 0.0)',
          target: 'body',
        })
        if (isLt6M) {
          resolve(file)
        } else {
          import('image-conversion').then(({ compressAccurately }) => {
            compressAccurately(file, 3072).then(resolve)
          })
        }
      })
    },
    async handleUpload(option) {
      try {
        const filePath = getFilePath(this.$route.name, option.file.name)
        const res = await ossClient(this.uploadConf).put(filePath, option.file)
        if (this.loading) this.loading.close()
        const url = this.uploadConf.domain + '/' + res.name
        this.form.imageList.push(res.name)
        option.onSuccess({ name: res.name, url })
      } catch (e) {
        if (this.loading) this.loading.close()
        option.onError(e)
      }
    },
    handleRemove(file) {
      const name = file.response ? file.response.name : file.name
      this.form.imageList = this.form.imageList.filter((n) => n !== name)
      this.fileList = this.fileList.filter((f) => f.uid !== file.uid)
    },
    handlePreview(file) {
      this.previewUrl = file.url
      this.previewVisible = true
    },
    handleExceed() {
      this.$message.warning('最多上传三张图片')
    },
    handleSubmit() {
      this.$refs.addForm.validate(async (valid) => {
        if (!valid) return
        this.submitting = true
        try {
          await addFollowRecordAPI({
            storeCode: this.storeCode,
            followContent: this.form.followContent,
            imageList: this.form.imageList,
          })
          this.$message.success('提交成功')
          this.dialogVisible = false
        } finally {
          this.submitting = false
        }
      })
    },
    getImageUrl(path) {
      if (!path) return ''
      if (path.startsWith('http')) return path
      const domain = this.uploadConf?.domain || localget('alioss')?.domain || ''
      return domain + '/' + path
    },
    handleClose() {
      this.$refs.addForm && this.$refs.addForm.resetFields()
      this.fileList = []
      this.form.imageList = []
      this.list = []
      this.dialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.store-info {
  font-size: 14px;
  margin-bottom: 16px;
}
.record-img {
  width: 60px;
  height: 60px;
  margin-right: 4px;
  cursor: pointer;
  vertical-align: middle;
}
.tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
</style>
